import React, { useEffect, useState } from "react";
import {
  Dialog,
  Box,
  Typography,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  IconButton,
} from "@mui/material";
import { _team_working_on_tasks_list } from "src/DAL/team";
import { useSnackbar } from "notistack";
import { Scrollbar, Iconify } from "src/components";
import { useNavigate } from "react-router-dom";
import { noTasks } from "src/assets";
import DashboardTaskCard from "src/pages/dashboard/components/DaashboardTaskCard";

export default function TeamTaskDialog({
  open,
  onClose,
  selectedUser,
  currentTeamTab,
}) {
  const [userTasks, setUserTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  // ---------------------------------------------------------------
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  // ------------------TEAM Working on Tasks------------------------
  const getTeamStartedTasksList = async () => {
    if (!selectedUser) return;
    setLoading(true);
    const workspaceIds = selectedUser.workspace.map(
      (workspace) => workspace._id
    );
    const req_data = {
      user_id: selectedUser.user_id,
      workspace_ids: workspaceIds,
      type:
        currentTeamTab === "all"
          ? "all_team"
          : currentTeamTab === "personal"
          ? "personal_team"
          : "assigned_team",
    };
    const result = await _team_working_on_tasks_list(req_data);
    if (result.code === 200) {
      setUserTasks(result.data);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setLoading(false);
  };

  const handleNavigate = (task) => {
    const { section_id, _id } = task;
    const project_id = task?.project.id;
    navigate(
      `/workspaces/copied-task-link/${project_id}/${section_id}/${_id}`,
      { state: { task_id: _id } }
    );
  };

  useEffect(() => {
    if (open && selectedUser) {
      getTeamStartedTasksList();
      console.log(selectedUser, "selected_user");
    }
  }, [open, selectedUser]);

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      {/* User Tasks --------------------- */}

      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: { xs: "8px 14px !important", md: "16px 24px !important" },
        }}
      >
        <Typography variant="h6">
          Started Tasks<b>{` - ${selectedUser?.first_name}`}</b>
        </Typography>
        <IconButton onClick={onClose} size="medium">
          <Iconify icon="mingcute:close-line" />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          padding: "8px !important",
          minHeight: "70vh",
          maxHeight: "70vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexGrow: 1,
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Scrollbar sx={{ maxHeight: "70vh", flexGrow: 1 }}>
            {userTasks.length > 0 ? (
              <Stack spacing={1} sx={{ padding: "4px 16px" }}>
                {userTasks.map((task, index) => (
                  <DashboardTaskCard
                    key={index}
                    task={task?.task_detail}
                    selectedUser={selectedUser}
                    isWorking={true}
                  />
                ))}
              </Stack>
            ) : (
              /* No Task --------------------- */
              <Box
                sx={{
                  height: "100%",
                  minHeight: "60vh",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Box
                  sx={{
                    width: "160px",
                    mb: 2,
                  }}
                >
                  <img width="100%" src={noTasks} alt="No Tasks" />
                </Box>

                <Typography
                  color={(theme) => theme.palette.text.disabled}
                  variant="body2"
                  fontWeight="bold"
                >
                  Not Found!
                </Typography>

                <Typography
                  color={(theme) => theme.palette.text.disabled}
                  variant="body2"
                >
                  There are no started tasks
                </Typography>
              </Box>
            )}
          </Scrollbar>
        )}
      </DialogContent>
    </Dialog>
  );
}
